<template>
  <div>
    <el-upload v-if="type=='file'" :headers="headers" class="upload-demo" ref="upload" :action="uploadurl" :on-remove="handleRemove" :on-exceed="exceed" :on-error="error" :on-success="success" :file-list="filelist" :auto-upload="true" :limit="limit" :on-preview="downLoadFile">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传文件</el-button> -->
      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>

    <el-upload v-else-if="type=='img'" :headers="headers" :accept="'image/jpg,image/jpeg,image/png,image/gif'" ref="upload" :action="uploadurl" :file-list="filelist" list-type="picture-card" :on-success="success" :on-error="error" :on-preview="handlePreview" :on-remove="handleRemove" :on-exceed="exceed" :auto-upload="true" :limit="limit" style="line-height: inherit;">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!-- <el-dialog :visible.sync="dialogVisible"  :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->

    <imagePreview ref="imagePreview" :url='imageurl'></imagePreview>
  </div>
</template>

<script>
import imagePreview from "@/components/ImagePreview.vue";
export default {
  name: "upload",
  components: {
    imagePreview
  },
  props: {
    value: {
      type: String,
      default: "",
    }, type: {//类型（img、file）
      type: String,
      default: "img",
    }, limit: {//文件最大数
      type: Number,
      default: 1
    }
  },
  mounted() {
    this.loadList();
  },
  watch: {
    value(newval, oldval)//监听值的变化，防止组件首次渲染之后，不在加载mounted方法。导致文件列表不刷新
    {
      this.loadList();
    }
  },
  data() {
    return {
      imageurl: '',
      headers: { Authorization: this.UserInfo.getToken() },
      filelist: [],//{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}
      uploadurl: this.http.ipAddress + 'api/Common/FileUpload'
    }
  },
  methods: {
    loadList() {//加载文件列表
      this.filelist = [];
      if (this.value != '' && this.value != undefined && this.value != null) {
        let imgArr = this.value.split(',');
        imgArr.forEach(item => {
          let arr = item.split('/');
          if (arr.length > 1) {
            this.filelist.push({ name: arr[arr.length - 1], url: item });
          }
        });
      }
    },
    handlePreview(file) {//预览图片
      this.imageurl = file.url;
      this.$refs.imagePreview.show = true;
    }, downLoadFile(file)//下载文件
    {
      this.$confirm('需要下载改文件吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        window.open(file.url);
      }).catch(error => {

      });

    }
    , submitUpload(file) {//手动上传
      this.$refs.upload.submit();
    },
    handleRemove(file, filelist) {
      this.filelist = filelist;
      this.updateUrl();
    }, success(response, file, filelist) {//上传成功
      if (response.Code == 1) {
        this.$message({
          message: '上传成功！',
          type: 'success'
        });
        let list = [];
        filelist.forEach(item => {
          if (item.uid == file.uid) {
            item.url = response.Data;
          }
          list.push(item);
        });
        this.filelist = list;
        this.updateUrl();
      } else {
        this.$message({
          message: response.Message,
          type: 'error'
        });
      }
    }, error() {//上传失败的时候
      this.$message({
        message: '上传失败',
        type: 'error'
      });
      this.updateUrl();
    }, handlePictureCardPreview(file) {

    }, exceed() {//文件超出时的函数
      this.$message({
        message: '最多上传' + this.limit + '个文件',
        type: 'warning'
      });
    }, updateUrl() {//修改父组件的值
      var v = [];
      this.filelist.forEach(item => {
        if (item.status == "success") {
          v.push(item.url);
        }
      });
      //this.$emit('update:value', v.join(','));//用：value.sync时需要改变父组件的值
      this.$emit('input', v.join(','));//用v-model时需要改变父组件的值
    }
  }
}
</script>

<style >
.el-upload--picture-card {
  line-height: 80px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
.el-upload--picture-card {
  width: 80px;
  height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/Upload.vue